export const SUPPORTED_CONNECTOR_PROTOCOL_VERSION = 1;
/** Maximum serialized envelope size (1 MiB). */
export const CONNECTOR_MAX_PAYLOAD_BYTES = 1024 * 1024;
export class ConnectorProtocolVersionError extends Error {
    name = "ConnectorProtocolVersionError";
    constructor(message) {
        super(message);
    }
}
export class ConnectorPayloadTooLargeError extends Error {
    name = "ConnectorPayloadTooLargeError";
    constructor(message) {
        super(message);
    }
}
//# sourceMappingURL=protocol.js.map